import Vue from 'vue';
import VueResource from 'vue-resource';

import store from '@/store/index';

Vue.use(VueResource);

Vue.http.interceptors.push((request, next) => {
    if (process.env.NODE_ENV === 'development') {
        // Для отправки CORS cookies
        request.credentials = true;
    }

    request.headers.set('X-CSRFToken', Vue.cookie.get('csrftoken'));

    next();
});

const _getAbsoluteUrl = (url) => {
    url = url.startsWith('/') ? url : '/' + url;
    return process.env.DJANGO_HOST + url;
};

// TODO: выпилить эту обёрточку и использовать нормальный интерфейс с Promise-ами
/**
 *   Оберточка для ajax-запросов
**/
export default function ajaxRequest({
    url,
    method = 'GET',
    params = {},
    success,
    failure
}) {
    let req;

    const shopNumber = store.state.localStorage.selectedShop.number;
    if (method === 'POST') {
        req = Vue.http.post(_getAbsoluteUrl(url), params, {
            params: {
                shop_number: shopNumber
            }
        });
    } else {
        req = Vue.http.get(_getAbsoluteUrl(url), {
            params: {
                ...params,
                shop_number: shopNumber
            }
        });
    }

    req.then(response => {
        if (response.body.success) {
            return success && success(response.body);
        } else {
            return failure && failure(response.body);
        }
    }, response => {
        // error callback
        // TODO: Надо бы реализовать!
    });
}

/**
 * Обёртка для fetch с сохранением его интерфейса и возвратом json-а.
 * @param url – относительный `url` запроса
 * @param init – данные или конфиги для fetch-а
 * @return {Promise<Object>}
 */
export const fetchWrapper = (url, init = {}) => {
    if (process.env.NODE_ENV === 'development') {
        // Отправка кук при CORS-запросах
        init.credentials = 'include';
    }
    if (init.body) {
        init.body = JSON.stringify(init.body);
    }

    const urlObject = new URL(process.env.DJANGO_HOST || window.location.origin);
    urlObject.pathname = url;
    urlObject.searchParams.append(
        'shop_number',
        store.state.localStorage.selectedShop.number
    );

    if (init.searchParams) {
        for (const [ name, value ] of Object.entries(init.searchParams)) {
            urlObject.searchParams.append(name, value);
        }

        delete urlObject.searchParams;
    }

    return fetch(
        urlObject.href,
        {
            ...init,
            headers: {
                'X-CSRFToken': Vue.cookie.get('csrftoken')
            }
        }
    ).then((response) => response.json())
        .then((responseJson) => {
            if (!responseJson.success) {
                throw responseJson;
            }
            return responseJson;
        });
};



// WEBPACK FOOTER //
// ./src/utils/request.js